<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-22 17:06:44
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-30 22:08:42
 * @FilePath: /notion-widgets-site/src/views/Edit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-container">
    <div class="page-container-header">
      <el-breadcrumb separator="››">
        <el-breadcrumb-item :to="{ path: '/mindex' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/mwids' }"
          >全部组件</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ item && item.tag }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <div class="preview">
        <h1>
          Preview · 预览<el-tag>
            当前组件 <i class="el-icon-view"></i>
            <!-- <span id="busuanzi_value_page_pv"></span>次 -->
            <span
              :id="hash"
              class="leancloud_visitors"
              :data-flag-title="item && item.tag"
            >
              <i class="leancloud-visitors-count"></i>
            </span>
          </el-tag>
        </h1>
        <iframe
          :src="item && item.link"
          frameborder="0"
          :class="item && item.size && item.size === 'auto' ? 'frame-auto' : ''"
        ></iframe>
      </div>
      <div class="settings">
        <h1>
          {{ item && item.tag
          }}<el-tag v-if="item && item.tags" type="danger" size="mini">{{
            item && item.tags
          }}</el-tag>
        </h1>
        <el-form ref="form" :model="form" label-width="80px" class="main-form">
          <el-alert
            class="desc-alert"
            v-if="item && item.desc"
            :title="item.desc"
            type="warning"
            show-icon
          ></el-alert>
          <el-form-item label="主题" v-if="item && item.mode === 'all'">
            <el-radio-group v-model="form.black" size="medium">
              <el-radio border :label="0">默认</el-radio>
              <el-radio border :label="1">暗黑</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="风格" v-if="item && item.theme">
            <el-select v-model="form.theme" placeholder="请选择">
              <el-option
                v-for="theme in item.theme"
                :key="theme.key"
                :label="theme.label"
                :value="theme.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图标" v-if="item && item.icons">
            <el-select v-model="form.icon" placeholder="请选择">
              <el-option
                v-for="_icon in item.icons"
                :key="_icon.key"
                :label="_icon.label"
                :value="_icon.key"
              >
              </el-option>
            </el-select>
            <!-- <div class="icon-preview"> -->
            <img :src="icon_preview" alt="" class="icon" />
            <!-- </div> -->
          </el-form-item>
          <template v-if="item && !item.color_unset">
            <el-form-item label="背景颜色" v-if="item && item.bg_color">
              <el-color-picker v-model="form.bg_color"></el-color-picker>
              <br />
              <template v-if="id === '32'"
                >PS: 需要将背景改为「无背景图」背景色才会生效</template
              >
            </el-form-item>
            <el-form-item label="字体颜色" v-if="item && item.font_color">
              <el-color-picker v-model="form.font_color"></el-color-picker>
            </el-form-item>
          </template>
          <setForm v-if="item" :id="id" :item="item" @on-form="onCustomize" />
          <template v-if="item && item.background">
            <el-form-item label="背景图片">
              <el-radio-group v-model="form.background">
                <el-radio
                  :label="radio.key"
                  v-for="radio in item.background"
                  :key="radio.key"
                >
                  <el-image
                    v-if="radio.url"
                    style="width: 50px; height: 50px"
                    :src="radio.url"
                  ></el-image>
                  <span v-else style="display: inline-block; width: 50px"
                    >无背景图</span
                  >
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <br />
          <el-form-item>
            <el-button
              type="primary"
              round
              v-clipboard:copy="item && item.link"
              v-clipboard:success="handleCopy"
              >立即创建</el-button
            >
          </el-form-item>
        </el-form>
        <footer-reward />
        <el-alert
          class="desc-alert"
          title="评论区"
          type="success"
          :closable="false"
          center
        ></el-alert>
        <div id="vcomments"></div>
      </div>
    </el-row>
    <!-- lock btn -->
    <el-button
      v-if="lockStatus"
      class="lock-btn"
      type="text"
      icon="el-icon-back"
      ><router-link :to="{ name: 'home' }">返回首页</router-link></el-button
    >
  </div>
</template>
<script>
import Valine from "valine";
import setForm from "../../components/create-aside/set.vue";
import FooterReward from "../../components/FooterReward.vue";
import lockMix from "../../mixins/lock";
export default {
  components: { setForm, FooterReward },
  mixins: [lockMix],
  data() {
    return {
      hash: window.location.hash,
      id: this.$route.params.id,
      type: this.$route.params.type,
      item: null,
      params: null,
      form: {
        black: 0,
        bg_color: "",
        font_color: "",
        theme: "",
        icon: "github",
        background: 9,
      },
      created: false,
      is_theme_link: false, // 不同主题链接分离
      is_expired: false,
      lock: null,
      lockStatus: false,
    };
  },
  computed: {
    icon_preview: function () {
      return require(`../../assets/logos/${this.form.icon}.png`);
    },
  },
  mounted() {
    console.log("mounted");
    this.getData();
    new Valine({
      el: "#vcomments",
      // other config
      appId: "wgD3lhLSAPHdLGH0gPy9Ep5n-gzGzoHsz",
      appKey: "DX5XDbJapqKFh8XT5myBkrcc",
      avatar: "hide",
      path: window.location.hash,
      visitor: true,
    });
  },
  methods: {
    getData() {
      const _this = this;
      const apis = {
        resources: "resources",
        efficiency: "efficiency",
        others: "others",
      };
      this.$axios
        .get(`./${apis[_this.type]}.json?v=${Math.random()}`)
        .then((res) => {
          let times = res.data.list.filter((item) => !item.hide);
          let item = times.find((item) => item.id === Number(_this.id));
          if (!item) return _this.openFullScreen2("该组件不存在");
          if (item.expired) {
            item.isExpired = new Date() > new Date(item.expired);
          }
          if (item && !item.isExpired) {
            _this.item = item;
            _this.form.bg_color = item.bg_color;
            _this.form.font_color = item.font_color;
            _this.item.original_link = item.link;
            item.theme && (_this.form.theme = item.theme[0].key);
            if (item.theme && item.theme[0].link) {
              _this.is_theme_link = true;
            }
          } else {
            // _this.$router.go(-2);
            _this.is_expired = true;
            _this.openFullScreen2();
          }
          if (item.close) {
            _this.openFullScreen2();
          }
        });
    },
    // custom parameter list
    onCustomize(params) {
      this.created = false;
      this.params = params;
      this.previewLink();
    },
    previewLink(newV = this.form) {
      const _this = this;
      let _p = { ...newV, ...this.params },
        _link = _this.item.original_link;
      console.log(_p);
      if (_this.is_theme_link) {
        let _theme = _this.item.theme.find(
          (item) => item.key === _this.form.theme
        );
        _link = _theme.link;
      }
      let encrypted = _this.$crypto.aseEncryptParams(JSON.stringify(_p));
      _this.item.link = `${_link}?e=${encrypted}`;
      console.log(_this.item.link);
    },
    createLink() {
      this.created = true;
    },
    handleCopy() {
      const _this = this;
      splitbee.track("Create widget in mobile", {
        type: _this.type,
        id: _this.id,
      });
      this.$message({
        message: "创建成功，快去粘贴到📒笔记软件内体验一下吧",
        type: "success",
      });
    },
  },
  watch: {
    form: {
      handler(newV, oldV) {
        this.previewLink(newV);
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
.page-container {
  padding: 0;
  &-header {
    padding-left: 30px;
    padding-bottom: 30px;
  }
  .settings,
  .aside,
  .preview {
    border-left: 1px solid #f3f3f3;
    height: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    overflow: auto;
    h1 {
      padding: 0 0 15px 0;
      border-bottom: 1px solid #f3f3f3;
      display: flex;
      align-items: center;
      .el-tag {
        margin-left: 20px;
      }
    }
    iframe {
      width: 100%;
      height: auto;
      max-height: 30vh;
      margin: 0 auto;
      display: block;
      &.frame-auto {
        width: 50%;
      }
    }
  }
  .preview {
    box-sizing: border-box;
    padding: 0 40px;
  }
}
.desc-alert {
  margin-bottom: 15px;
}
.icon-preview {
  // display: inline-flex;
}
// .icon-box {
//   height: 100%;
//   display: flex;
//   align-items: center;
.icon {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}
.leancloud_visitors {
  margin-left: 5px;
}
// }
.lock-btn {
  position: fixed;
  top: 50%;
  z-index: 2006;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 90px;
}
</style>
